import Image from "next/image";
import { urlFor } from "../lib/sanityImage";

export default function SanityImage({
  image,
  aspectRatio = "5:4",
  alt = "",
  className = "",
  sizes = "100vw",
}) {
  const [widthRatio, heightRatio] = aspectRatio.split(":").map(Number);
  const paddingTop = (heightRatio / widthRatio) * 100;

  return (
    <div
      className={`relative w-full overflow-hidden ${className}`}
      style={{ paddingTop: `${paddingTop}%` }}
    >
      <Image
        src={urlFor(image).width(1200).height(1200).fit("crop").url()}
        alt={alt}
        fill
        className="object-cover"
        sizes={sizes}
      />
    </div>
  );
}
